<template>
  <div class="base-text-row">
    <div v-if="row" v-html="row.text" :class="textSizes" class="leading-snug max-w-5xl body"></div>
  </div>
</template>

<script>
export default {
  name: 'BaseTextRow',
  props: {
    row: Object
  },
  computed: {
    textSizes () {
      const opts = {
        s: 'lg:text-xl',
        r: 'text-lg lg:text-2xl',
        l: 'text-xl lg:text-3xl'
      }
      const pick = this.row.size || 'r'

      return opts[pick]
    }
  }
}
</script>

<style lang="css" scoped>
  >>> a {
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 4px;
  }
</style>
